import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Button } from '@mui/material';
import { Edit } from '@mui/icons-material';

const EditButton = (props) => {
  return (
    <Tooltip title="Edit" describeChild>
      <span>
        <Button
          aria-label="Edit"
          data-cy={props.dataCy ? props.dataCy : `edit-button${props.id}`}
          onClick={props.onClick}
          disabled={props.disabled}
          className={['editButton', props.className].filter(Boolean).join(' ')}
          variant="contained"
          style={{ textTransform: 'none' }}
          size="small"
        >
          <Edit />
        </Button>
      </span>
    </Tooltip>
  );
};

EditButton.propTypes = {
  id: PropTypes.string,
  dataCy: PropTypes.string, // data-cy tag
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default EditButton;
